import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getSubreddits = createAsyncThunk(
    'subreddit/fetchSubreddits',
    async () => {
        const response = await fetch('https://www.reddit.com/subreddits.json');
        const resJson = await response.json();
        const subreddits = await resJson.data.children;
        return subreddits;
    }
)

const initialState = {
    subreddits: [
        { data: { id: 1, title: "home" } },
        { data: { id: 2, title: "AskReddit" } },
        { data: { id: 3, title: "antiwork" } },
        { data: { id: 4, title: "funny" } },
        { data: { id: 5, title: "memes" } }
    ],
    error: false,
    isLoading: false
}

const options = {
    name: 'subreddit',
    initialState,
    reducers: {},
    extraReducers: {
        [getSubreddits.pending]: (state, action) => {
            state.error = false
            state.isLoading = true
        },
        [getSubreddits.fulfilled]: (state, action) => {
            state.error = false
            state.isLoading = false
            state.subreddits = action.payload
        },
        [getSubreddits.rejected]: (state, action) => {
            state.error = true
            state.isLoading = false
        }
    }
}

const subredditSlice = createSlice(options);
export default subredditSlice.reducer; 
export const selectSubreddits = state => state.subreddit.subreddits;